import { ApiEndpoint } from "@/app/apiEndpoint";
import axios from "@/app/http/axios";
import { FormPattern, FormStep } from "@/interface/Form.interface";

export default class FormService {
  constructor() {}

  async getAllForms() {
    const path = ApiEndpoint.Form.GET_ALL;
    try {
      const response = await axios.get<FormPattern[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getFormsWithConditions(filter: any) {
    const path = ApiEndpoint.Form.SEARCH;
    try {
      const response = await axios.post<FormPattern[]>(`${path}`, filter);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getFormById(id: number) {
    const path = ApiEndpoint.Form.GET_BY_ID;
    try {
      const response = await axios.get<FormPattern>(
        `${path.replace("{id}", id.toString())}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getAllSteps() {
    const path = ApiEndpoint.Form.GET_ALL_STEPS;
    try {
      const response = await axios.get<FormStep>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
